module.exports = __webpack_public_path__ + "img/comment-arrow-up.a58e6dda.svg";